module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por:")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v("\n                " + _vm._s(option.label) + "\n              ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getPurchaseOrdersByPage()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block filter-block-alone"
  }, [_c('label', [_vm._v("Estado:")]), _vm._v(" "), _c('div', {
    staticClass: "multiselect form-control",
    attrs: {
      "id": "checkboxes2"
    }
  }, [_c('div', {
    staticClass: "selectBox"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeEstado),
      expression: "typeEstado"
    }],
    staticClass: "kt-form__label",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeEstado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeEstadoListOrder(_vm.typeEstado)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Activos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Cancelados")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-bloc filter-block-alone"
  }, [_c('label', [_vm._v("Canal de venta:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "store", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all",
      "selected": ""
    }
  }, [_vm._v("Todo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sendi",
      "data-content": "<span class='badge badge-info'>Ofertas de Grabr</span>"
    }
  }, [_vm._v("\n              Sendi\n            ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "enviosusa",
      "data-content": "<span class='badge badge-warning'>Ofertas no Grabr</span>"
    }
  }, [_vm._v("\n              Envios Usa\n            ")])])])]), _vm._v(" "), (_vm.tableData.order_type === 4) ? _c('div', {
    staticClass: "filter-bloc"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('form', {
    staticClass: "formulario",
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [(this.valorRadioButton == true) ? _c('span', [_c('input', {
    attrs: {
      "type": "radio",
      "id": "inicio"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inicio"
    }
  }, [_vm._v("Todo")])]) : (this.valorRadioButton == false) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "todo"
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.tableData.store, null)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", null)
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "todo"
    }
  }, [_vm._v("Todo")])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "electro"
    },
    domProps: {
      "value": 'electro',
      "checked": _vm._q(_vm.tableData.store, 'electro')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'electro')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "electro"
    }
  }, [_vm._v("Electro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "fashion"
    },
    domProps: {
      "value": 'fashion',
      "checked": _vm._q(_vm.tableData.store, 'fashion')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'fashion')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "fashion"
    }
  }, [_vm._v("Fashion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "kids"
    },
    domProps: {
      "value": 'kids',
      "checked": _vm._q(_vm.tableData.store, 'kids')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'kids')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kids"
    }
  }, [_vm._v("Kids")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "home"
    },
    domProps: {
      "value": 'home',
      "checked": _vm._q(_vm.tableData.store, 'home')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'home')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "home"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "pets"
    },
    domProps: {
      "value": 'pets',
      "checked": _vm._q(_vm.tableData.store, 'pets')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'pets')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pets"
    }
  }, [_vm._v("Pets")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-orders"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [(_vm.purchaseOrders != null && _vm.purchaseOrders.length > 0) ? _c('tbody', _vm._l((_vm.diasRestantes), function(purchaseOrder) {
    return _c('router-link', {
      key: purchaseOrder.id,
      attrs: {
        "to": {
          name: 'show-purchase-order',
          params: {
            id: purchaseOrder.id,
            orderData: purchaseOrder
          },
        }
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "image-table"
    }, [(purchaseOrder.attributes.product_image_url) ? _c('img', {
      attrs: {
        "src": purchaseOrder.attributes.product_image_url,
        "width": "180px",
        "height": "260px"
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/images/image-package.png"),
        "width": "180px",
        "height": "260px"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "description-title"
    }, [_c('span', {
      staticClass: "description-title-principal"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.product_info))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "code-order system-code"
    }, [_vm._v("QTY:" + _vm._s(purchaseOrder.attributes.product_specimens) + " | SB #" + _vm._s(purchaseOrder.id) + "\n                    ")]), _vm._v(" "), (purchaseOrder.attributes.is_from_linio_flag) ? _c('span', {
      staticClass: "code-order grabr-code"
    }, [_vm._v("\n                      #" + _vm._s(purchaseOrder.attributes.linioOrder.attributes.linio_order_id))]) : (purchaseOrder.attributes.is_from_meli_flag) ? _c('span', {
      staticClass: "code-order grabr-code"
    }, [_vm._v("\n                      #" + _vm._s(purchaseOrder.attributes.meliOrder.attributes.meli_order_id))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary",
      class: purchaseOrder.attributes.status == 10 ?
        'bg-danger' :
        'bg-success'
    }, [_vm._v("\n                      " + _vm._s(purchaseOrder.attributes.status == 10 ? "Cancelada" : "Activa") + "\n                    ")]), _vm._v(" "), (purchaseOrder.attributes.type === 2) ? _c('span', {
      staticClass: "badge badge-primary bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.store))]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.type === 2) ? _c('span', {
      staticClass: "badge badge-primary bg-success"
    }, [(purchaseOrder.attributes.store === 'sendi') ? _c('span', [_vm._v("\n                        " + _vm._s(purchaseOrder.attributes.direct_type === 1 ? 'Courier' : 'Shopper') + "\n                      ")]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.store === 'enviosusa') ? _c('span', [_vm._v("\n                       " + _vm._s(purchaseOrder.attributes.direct_type === 1 ? 'Lite' : 'Premium') + "\n                      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.reference_link) ? _c('span', {
      staticClass: "badge badge-primary bg-primary"
    }, [_vm._v(_vm._s(_vm.getStore(purchaseOrder.attributes.reference_link)))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary bg-secondary"
    }, [_vm._v("WR -" + _vm._s(purchaseOrder.attributes.warehouse_admin))])]), _vm._v(" "), (purchaseOrder.attributes.is_from_grabr_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-grabr"
    }, [_vm._v("Grabr")]), _vm._v(" "), _c('span', {
      staticClass: "code-order grabr-code",
      on: {
        "click": function($event) {
          return _vm.toGrabrDetail(
            purchaseOrder.attributes.grabrOrder.attributes
            .grabr_order_number
          )
        }
      }
    }, [_vm._v(_vm._s(purchaseOrder.attributes.grabrOrder.attributes
      .grabr_order_number))])]) : (purchaseOrder.attributes.is_from_linio_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-linio"
    }, [_vm._v("Linio")])]) : (purchaseOrder.attributes.is_from_meli_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-meli"
    }, [_vm._v("Mercado libre")]), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store ===
      'electro'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store bg-primary"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                    ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store === 'kids'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store magenta"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                    ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store ===
      'fashion'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store brown"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                    ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store === 'home'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v("\n                    Tracking: " + _vm._s(purchaseOrder.attributes.system_tracking_number) + "\n                  ")])])]), _vm._v(" "), (
      purchaseOrder.attributes.origin != undefined &&
      purchaseOrder.attributes.destination != undefined
    ) ? _c('td', [_c('div', {
      staticClass: "ruta-order-container"
    }, [_c('div', {
      staticClass: "ruta-order-block ruta-order-image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/ruta.svg",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-block"
    }, [_c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(purchaseOrder.attributes.origin.attributes.name))])]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(purchaseOrder.attributes.destination_address))])])])])]) : _c('td', [_c('span', {
      staticClass: "ruta-order"
    }, [_vm._v("No se ha definido")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "order-tag-container"
    }, [_c('span', [_c('img', {
      attrs: {
        "src": "/static/img/icon-pago-status.png",
        "width": "20",
        "alt": ""
      }
    }), _vm._v(" "), (purchaseOrder.attributes.payed === 1) ? _c('span', [_vm._v("PENDIENTE")]) : (purchaseOrder.attributes.payed === 2) ? _c('span', [_vm._v("EN PROCESO")]) : (purchaseOrder.attributes.payed === 3) ? _c('span', [_vm._v("CONFIRMADO")]) : (purchaseOrder.attributes.payed === 10) ? _c('span', [_vm._v("RECHAZADO\"")]) : (purchaseOrder.attributes.payed === 11) ? _c('span', [_vm._v("RECLAMADO")]) : (purchaseOrder.attributes.payed === 12) ? _c('span', [_vm._v("RETORNADO")]) : _vm._e()]), _vm._v(" "), _c('span', [_c('ul', [_c('li', [_c('span', [(purchaseOrder.attributes.payment_method_flag === 5) ? _c('span', [(purchaseOrder.attributes.payment_code === null) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.payment_code !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 2) ? _c('span', [(
      purchaseOrder.attributes.paypalPayment.attributes
      .paypal_order_id === null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.paypalPayment.attributes
      .paypal_order_id !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 3) ? _c('span', [(
      purchaseOrder.attributes.mercadopagoPayment.attributes
      .payment_id === null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.mercadopagoPayment.attributes
      .payment_id !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 4) ? _c('span', [(
      purchaseOrder.attributes.atm_payment.mp_payment_id ===
      null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.atm_payment.mp_payment_id !==
      null && purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 6) ? _c('span', [_vm._v("Pago con saldo")]) : _vm._e(), _vm._v("\n                          - Código")])]), _vm._v(" "), _c('li', [(purchaseOrder.attributes.voucher_link === null) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.voucher_link !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-3.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-2.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e(), _vm._v("\n                        - Voucher\n                      ")])])]), _vm._v(" "), _c('span', [_c('img', {
      attrs: {
        "src": "/static/img/icon-tracking-statu.png",
        "width": "20",
        "alt": ""
      }
    }), _vm._v(" "), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 1
    ) ? _c('span', [_vm._v("\n                      EN REVISIÓN")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 2
    ) ? _c('span', [_vm._v("\n                      COMPRADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 3
    ) ? _c('span', [_vm._v("\n                      PREPARANDO PARA ENVIAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 4
    ) ? _c('span', [_vm._v("\n                      LISTO PARA ENVIAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 5
    ) ? _c('span', [_vm._v("\n                      ENVIADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 6
    ) ? _c('span', [_vm._v("\n                      LISTO PARA ENTREGAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 7
    ) ? _c('span', [_vm._v("\n                      ENTREGADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 8
    ) ? _c('span', [_vm._v("\n                      SINIESTRADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 9
    ) ? _c('span', [_vm._v("\n                      EN PROCESO DE DEVOLUCIÓN")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 10
    ) ? _c('span', [_vm._v("\n                      RETORNADO AL PROVEEDOR")]) : _vm._e()])])]), _vm._v(" "), _c('td', [_c('span', {}, [(purchaseOrder.attributes.vouchers_usa.length !== 0) ? _c('img', {
      attrs: {
        "src": "/static/img/statuFactura/factura-1.svg",
        "width": "50",
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/img/statuFactura/factura-2.svg",
        "width": "50",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('td', [_c('ul', [_c('li', [_vm._v("\n                    B:" + _vm._s(_vm._f("spanishDate")(purchaseOrder.attributes.order_create_date)) + "\n                  ")]), _vm._v(" "), (
      purchaseOrder.attributes.hasOwnProperty('promised_delivery_date')
    ) ? _c('li', [_c('span', [_vm._v("\n                      D:\n                      " + _vm._s(_vm._f("spanishDate")(purchaseOrder.attributes.promised_delivery_date)) + "\n                      |\n                      "), (purchaseOrder.resultado > 15) ? _c('span', {
      staticClass: "badge badge-primary bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.resultado) + " días")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.resultado > 10 && purchaseOrder.resultado <= 15
    ) ? _c('span', {
      staticClass: "badge badge-primary bg-warning"
    }, [_vm._v("\n                        " + _vm._s(purchaseOrder.resultado) + " días\n                      ")]) : _vm._e(), _vm._v(" "), (purchaseOrder.resultado <= 10) ? _c('span', {
      staticClass: "badge badge-primary bg-danger"
    }, [(Math.sign(purchaseOrder.resultado) === 1) ? _c('span', [_vm._v(_vm._s(purchaseOrder.resultado) + " días\n                        ")]) : _vm._e(), _vm._v(" "), (Math.sign(purchaseOrder.resultado) === -1) ? _c('span', [_vm._v("\n                          Retraso de\n                          " + _vm._s(Math.abs(purchaseOrder.resultado)) + " dias")]) : _vm._e(), _vm._v(" "), (Math.sign(purchaseOrder.resultado) === 0) ? _c('span', [_vm._v("\n                          Retraso")]) : _vm._e()]) : _vm._e()])]) : _c('li', [_vm._v("No definido")])])])])])
  }), 1) : _c('tbody', [_c('div', {
    staticClass: "no-results"
  }, [_c('h1', [_vm._v("No se encontraron resultados")])])])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPurchaseOrdersByPage
    }
  }) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "formmodal",
    attrs: {
      "id": "formmodal",
      "centered": "",
      "hide-footer": "",
      "hide-header": ""
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Nueva oferta de compra")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccione de donde proviene la oferta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grabr.id),
      expression: "grabr.id"
    }],
    staticClass: "form-control form-control-lg",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.grabr, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.$store.state.user.attributes.permissions_keys.includes(6)) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n              Órdenes GRABR\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(7)) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("\n              Órdenes DIRECT\n            ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'add-purchase-order',
        params: {
          grabr: _vm.grabr,
          oldID: null
        },
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Continuar")])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Órdenes de compra")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-411f8ca0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/OrderTable.vue
// module id = 1871
// module chunks = 1